import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import ActivateIcon from '@material-ui/icons/LockOpen';
import DeactivateIcon from '@material-ui/icons/Lock';
import ResetIcon from '@material-ui/icons/Redo';
import LinkIcon from '@material-ui/icons/Link';
import TextField from '@material-ui/core/TextField';
import DataTable from './shared/DataTable';
import Typography from '@material-ui/core/Typography';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {observer} from "mobx-react";
import moment from 'moment'
import 'moment-timezone';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import AsyncSelect from "react-select/async";

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 300
    },
    successButton: {
        margin: theme.spacing.unit,
        color: "white",
        backgroundColor: "#2A9D8F",
        '&:hover': {
            backgroundColor: "#2A9D8F",
        },
    },
    warningButton: {
        margin: theme.spacing.unit,
        color: "white",
        backgroundColor: "#E9190F",
        '&:hover': {
            backgroundColor: "#E9190F",
        },
    },
    stickerSelect: {
        width: "300px",
        margin: theme.spacing.unit,
    },
    appBar: {
        backgroundColor: 'white',
        top: 'auto',
        bottom: 0,
    }
});

class UserDetails extends Component
{

    constructor(props)
    {
        super(props);
        this.tableColumns = [
            {name: "ID", field: "identifier", sortable: false},
            {name: "Beschreibung", field: "title", sortable: false},
            {name: "Aktiviert", field: "granted", type: "date", sortable: false},
            {name: "Produkt", field: "icon_key", type: "image", sortable: false},
            /* {name: "Zuordnung aufheben", field: "", type: "deleteButton", sortable: false} */
        ]

        this.state = {
            stickersToAssign: []
        }

        this.props.userStore.detailRoute = "/users"
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelectInputChange = this.handleSelectInputChange.bind(this);
        this.deleteFunction = this.deleteFunction.bind(this);
        this.addFunction = this.addFunction.bind(this);
    }


    componentDidMount()
    {
        this.props.userStore.getUser(this.props.match.params.id);
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.props.userStore.user[name] = value;
    }

    handleSubmit(event)
    {
        this.props.userStore.saveUser(this.props.match.params.id);
        event.preventDefault();
    }

    enableUser()
    {
        this.props.userStore.enableUser(this.props.match.params.id);
    }

    disableUser()
    {
        this.props.userStore.disableUser(this.props.match.params.id);
    }

    resetPassword()
    {
        this.props.userStore.resetPassword(this.props.match.params.id);
    }

    assignSticker()
    {
        this.props.userStore.assignSticker(this.props.match.params.id, this.state.stickersToAssign);
        this.setState({stickersToAssign: []})
    }

    addFunction(value1, value2)
    {
        //console.log(value1, value2);
    }

    deleteFunction(value)
    {
        this.props.userStore.unassignSticker(this.props.match.params.id, value);
    }

    handleSelectInputChange(selection)
    {
        if (selection)
        {
            this.setState({
                stickersToAssign: selection.map(function (sticker)
                {
                    return sticker.value;
                })
            })
        }
    }

    render()
    {
        const {classes} = this.props;

        const loadOptions = (inputValue) =>
        {
            if (!inputValue)
            {
                return Promise.resolve([]);
            }
            return this.props.stickerStore.findStickers(inputValue)
                .then((stickers) => stickers.map((sticker) => ({label: sticker.identifier, value: sticker.uuid})));
        };

        return (
            <div>
                <ToastContainer/>
                <Typography variant="title" gutterBottom>
                    Benutzer: {this.props.userStore.user.email}
                </Typography>
                <form noValidate autoComplete="off">
                    <Grid container spacing={16} style={{marginBottom: 30}}>
                        <Grid item>
                            <TextField
                                id="id"
                                name="id"
                                label="ID"
                                className={classes.textField}
                                value={this.props.userStore.user.uuid || ''}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="email"
                                name="email"
                                label="E-Mail"
                                className={classes.textField}
                                value={this.props.userStore.user.email || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="enabled"
                                name="enabled"
                                label="Aktiv"
                                className={classes.textField}
                                value={this.props.userStore.user.enabled ? "Ja" : "Nein"}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="status"
                                name="status"
                                label="Status"
                                className={classes.textField}
                                value={this.props.userStore.user.status || ''}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="registered"
                                name="registered"
                                label="Registriert"
                                className={classes.textField}
                                value={this.props.userStore.user.registered ? moment(this.props.userStore.user.registered).format("DD.MM.YYYY / HH:mm") : 'Nie'}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="modified"
                                name="modified"
                                label="Zuletzt bearbeitet"
                                className={classes.textField}
                                value={this.props.userStore.user.modified ? moment(this.props.userStore.user.modified).format("DD.MM.YYYY / HH:mm") : 'Nie'}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                        </Grid>
                    </Grid>
                </form>
                <hr/>
                <Typography variant="subheading" gutterBottom>
                    Sticker des Benutzers
                </Typography>
                <Grid container style={{marginBottom: 30}}>
                    <Grid item>
                        <div style={{display: "inline-flex"}}>
                            <AsyncSelect
                                loadOptions={loadOptions}
                                isClearable
                                isMulti
                                placeholder="Sticker ID"
                                className={classes.stickerSelect}
                                onChange={this.handleSelectInputChange}
                            />
                        </div>
                        <Button variant="contained" size="small" color="primary" onClick={() => this.assignSticker()} className={classes.button}>
                            <LinkIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Sticker zuordnen
                        </Button>
                    </Grid>
                </Grid>
                <Grid container spacing={16}>
                    <DataTable
                        store={this.props.userStore}
                        detailRoute="/stickers"
                        rows={this.props.userStore.stickerList}
                        columns={this.tableColumns}
                        history={this.props.history}
                        addFunction={this.addFunction}
                        deleteFunction={this.deleteFunction}
                    />
                </Grid>
                <AppBar position="fixed" color="primary" className={classes.appBar}>
                    <Toolbar>
                        <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="flex-start">
                            <Grid item>
                                {this.props.userStore.user.enabled &&
                                    <Button variant="contained" size="small" color="default" onClick={() => this.disableUser()}
                                            className={classes.warningButton}>
                                        <DeactivateIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Deaktivieren
                                    </Button>
                                }
                                {!this.props.userStore.user.enabled &&
                                    <Button variant="contained" size="small" color="primary" onClick={() => this.enableUser()}
                                            className={classes.successButton}>
                                        <ActivateIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Aktivieren
                                    </Button>
                                }
                            </Grid>
                            <Grid item>
                                <Button variant="contained" size="small" color="primary" onClick={() => this.resetPassword()} className={classes.button}>
                                    <ResetIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                    Kennwort zurücksetzen
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" size="small" color="secondary" onClick={this.handleSubmit.bind(this)} className={classes.button}>
                                    <SaveIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                    Speichern
                                </Button>
                            </Grid>
                        </Grid>
                        <div className={classes.grow}/>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

export default withStyles(styles)(observer(UserDetails));
